import { render, staticRenderFns } from "./SocialLoginCallback.vue?vue&type=template&id=2076d90e&scoped=true"
import script from "./SocialLoginCallback.vue?vue&type=script&lang=js"
export * from "./SocialLoginCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076d90e",
  null
  
)

export default component.exports